
export enum LabStatus{
    SUCCESS="success"
}

export type CoaFile = {
    url: string;
    fileName: string;
    testPerformedDate: string;
    labTestingStateName: string;
    testerName: string;
    labLicenseNumber: string;
};

export type CoaCardProps = {
    selectionKey?: string;
    cultivatorName: string;
    id: string;
    testerName: string;
    date: string;
    labLicenseNumber: string;
    labStatus: string;
    files: CoaFile[];
};

export const getCoaSelectionKey = (coa: CoaCardProps): string => coa.selectionKey || coa.id;


function CoaCard({ coa }: { coa: CoaCardProps | null }) {

    return (
        <div className="coa-card" data-testid={`coa-card-${coa?.id || 'empty'}`}>
            <CoaRow label="UID" value={coa?.id || ''} />
            <CoaRow label="Cultivator" value={coa?.cultivatorName || ''} />
            <CoaRow label="Tested By" value={coa?.testerName || ''} />
            <CoaRow label="Lab #" value={coa?.labLicenseNumber || ''} />
            <CoaRow label="Date Tested" value={coa?.date || ''}/>
            <CoaRow label="Status" value={coa?.labStatus || ''} isLast={true} isLabStatus={true}/>
        </div>
    );
}

function CoaRow({ label, value, isLast, isLabStatus }: { label: string; value: string; isLast?: boolean; isLabStatus?: boolean }) {
    const fieldKey = label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

    return (
        <div>
        <div className="coa-row" data-testid={`coa-card-row-${fieldKey}`}>
            <div className="coa-label" data-testid={`coa-card-label-${fieldKey}`}>{label}</div>
            {
                !isLabStatus || !value || value !== LabStatus.SUCCESS
                    ? <div className="coa-value" data-testid={`coa-card-value-${fieldKey}`}>{value}</div>
                    : <img src={`/images/lab-status-${value}.svg`} alt={`${value} status icon`} data-testid={`coa-card-value-${fieldKey}`} />
            }
            
           
        </div>
         {
                !isLast && <CoaRowDivider />
            }
        </div>
    );
}

function CoaRowDivider(){
    return (
        <hr className="coa-row-divider" />
    );
}

export default CoaCard;
